import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=3ff04682&scoped=true"
import script from "./AppForm.vue?vue&type=script&lang=js"
export * from "./AppForm.vue?vue&type=script&lang=js"
import style0 from "./AppForm.vue?vue&type=style&index=0&id=3ff04682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff04682",
  null
  
)

export default component.exports